import Button from 'Components/Button';
import CardStadistics from 'Components/CardStadistics';
import Label from 'Components/Label';
import ProgressBar from 'Components/ProgressBar';
import SelectUsers from 'Components/SelectUsers';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import EstadisticasService from 'Services/Http/Estadisticas.service';
import { formatCurrency, formatPercentage } from 'Utils/Functions';

const ListarCreditoOperadores = () => {
  const { pagos } = useSelector((state) => state.session.session);
  const [records, setRecords] = useState([]);
  const [loader, setLoader] = useState(false);
  const [idUser, setIdUser] = useState(null);
  const [estadistica, setEstadistica] = useState({});
  const [urlReport, setUrlReport] = useState('');
  useEffect(() => {
    getAllPromotores();
  }, []);
  const getAllPromotores = async () => {
    setLoader(true);
    try {
      const urlResponse = await EstadisticasService.downloadPromotor({ idUser });
      setUrlReport(urlResponse.data);
      const response = await EstadisticasService.promotor({ idUser });
      const { records, ...rest } = response.data;
      createRows(records);
      setEstadistica(rest);
      setLoader(false);
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  };

  const openFile = () => {
    let w = window.open(urlReport, '_blank');
    w.opener = null;
  };

  const createRows = (rows) => {
    let data = rows.map((item, index) => (
      <tr
        key={'clientes-row-' + index}
        className="odd:bg-white even:bg-blue-100 border-b hover:bg-blue-300 hover:cursor-pointer">
        <td className="px-6 py-4">{item.id}</td>
        <td className="px-6 py-4">{item.nombreCompleto}</td>
        <td className="px-6 py-4">{item.user}</td>
        <td className="px-6 py-4">{item.creditos}</td>
        <td className="px-6 py-4">{item.clientes}</td>
        <td className="px-6 py-4">{item.creditoMora}</td>
        <td className="px-6 py-4">{formatCurrency(item.totalCartera)}</td>
        <td className="px-6 py-4">{formatCurrency(item.sana)}</td>
        <td className="px-6 py-4">{formatCurrency(item.mora)}</td>
        <td className="px-6 py-4">{formatPercentage(item.porcentajeMora)}</td>
      </tr>
    ));
    setRecords(data);
  };

  useEffect(() => {
    getAllPromotores();
  }, [idUser]);

  return (
    <>
      <Label text={'Estadisticas por promotor'} />
      {pagos ? (
        <div className="flex flex-row my-5 lg:w-2/5 md:w-100 justify-stretch">
          <SelectUsers onChange={setIdUser} />
          <Button iconprefix={['fa', 'download']} onClick={() => openFile()} />
        </div>
      ) : (
        ''
      )}
      <div className="flex flex-col grid lg:grid-cols-4 md:grid-cols-2 gap-3 my-3 justify-stretch">
        <CardStadistics title={'Creditos'} texto={estadistica.creditos || 0} />
        <CardStadistics title={'Clientes'} texto={estadistica.clientes || 0} />
        <CardStadistics title={'Creditos en mora'} texto={estadistica.creditosMora || 0} />
      </div>
      <div className="flex flex-col grid lg:grid-cols-4 md:grid-cols-2 gap-3 my-3 justify-stretch">
        <CardStadistics title={'Cartera Total'} texto={formatCurrency(estadistica.cartera || 0)} />
        <CardStadistics
          title={'Monto cartera sana'}
          texto={formatCurrency(estadistica.sana || 0)}
        />
        <CardStadistics title={'Monto en mora'} texto={formatCurrency(estadistica.mora || 0)} />
        <CardStadistics
          title={'Porcentaje de mora'}
          texto={formatPercentage(estadistica.porcentaje || 0)}
        />
      </div>
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left rtl:text-right text-black">
          <thead className="text-xs text-white uppercase bg-blue-500">
            <tr>
              <th scope="col" className="px-6 py-3">
                #
              </th>
              <th scope="col" className="px-6 py-3">
                Nombre completo
              </th>
              <th scope="col" className="px-6 py-3">
                Usuario
              </th>
              <th scope="col" className="px-6 py-3">
                Creditos
              </th>
              <th scope="col" className="px-6 py-3">
                Clientes
              </th>
              <th scope="col" className="px-6 py-3">
                Creditos en mora
              </th>
              <th scope="col" className="px-6 py-3">
                Cartera total
              </th>
              <th scope="col" className="px-6 py-3">
                Monto cartera sana
              </th>
              <th scope="col" className="px-6 py-3">
                Monto en mora
              </th>
              <th scope="col" className="px-6 py-3">
                Porcentaje de mora
              </th>
            </tr>
          </thead>
          <tbody>{records}</tbody>
        </table>
        {loader ? <ProgressBar /> : ''}
      </div>
    </>
  );
};

export default ListarCreditoOperadores;
